(() => {
  
  const header = document.querySelector('[data-trc-header]');
  
  if (!header) return;

  // -------------------------
  // Scroll hide/show
  // -------------------------
  let lastY = window.scrollY || 0;
  let ticking = false;

  const SHOW_AT_TOP = 12;
  const DELTA = 6;

  const onScroll = () => {
    const y = window.scrollY || 0;
    const diff = y - lastY;

    if (y <= SHOW_AT_TOP) {
      header.classList.remove('trc-h--hidden');
      lastY = y;
      return;
    }

    if (Math.abs(diff) < DELTA) return;

    if (diff > 0) header.classList.add('trc-h--hidden');
    else header.classList.remove('trc-h--hidden');

    lastY = y;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true }
  );

  // -------------------------
  // Mobile drawer controls + body scroll lock
  // -------------------------
  const drawer = header.querySelector('details[data-trc-drawer]');
  
  if (!drawer) return;

  const closeBtn = header.querySelector('[data-trc-drawer-close]');
  const scrim = header.querySelector('[data-trc-drawer-scrim]');

  let lockedScrollY = 0;

  const lockBodyScroll = () => {
    lockedScrollY = window.scrollY || 0;
    document.documentElement.classList.add('trc-no-scroll');
    document.body.classList.add('trc-no-scroll');
    // iOS: fixed body jump'ını engelle
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockBodyScroll = () => {
    document.documentElement.classList.remove('trc-no-scroll');
    document.body.classList.remove('trc-no-scroll');
    const top = document.body.style.top;
    document.body.style.top = '';
    // iOS: eski pozisyona geri dön
    if (top) {
      const y = Math.abs(parseInt(top, 10)) || 0;
      window.scrollTo(0, y);
    }
  };

  const closeDrawer = () => {
    
    drawer.open = false;
  };

  // details open/close izleyip scroll lock uygula
  drawer.addEventListener('toggle', () => {
    if (drawer.open) lockBodyScroll();
    else unlockBodyScroll();
  });

  // Close button
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Scrim click
  if (scrim) scrim.addEventListener('click', closeDrawer);

  // Close on link clicks (parent links + sublinks + CTA)
  header.addEventListener('click', (e) => {
    if (!drawer.open) return;
    const link = e.target.closest('.trc-h__drawer-link, .trc-h__drawer-sublink, .trc-h__cta--drawer');
    if (link) closeDrawer();
  });

  // ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.open) closeDrawer();
  });

  // Outside click safety (if needed)
  document.addEventListener('click', (e) => {
    if (!drawer.open) return;
    if (!header.contains(e.target)) closeDrawer();
  });
})();
